// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 固定容器的宽度为1200px */
.DailyPlan_container__lXHTB {
    width: 1200px;
    margin: auto;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 中心对齐标题 */
h2 {
    text-align: center;
    margin-bottom: 40px;
    font-weight: 700;
    color: #343a40;
}

/* 任务列表垂直排列，宽度为100% */
.DailyPlan_taskList__p28dx {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    margin-top: 20px;
}

/* 类别组的样式 */
.DailyPlan_categoryGroup__z2aIK {
    border: 1px solid #ddd;
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

/* 类别标题的样式 */
.DailyPlan_categoryTitle__MgcOr {
    margin-bottom: 20px;
    font-weight: 600;
}

/* 任务详情的样式 */
.DailyPlan_taskDetails__\\+t3xy {
    margin-top: 10px;
    padding: 20px;
    border: 1px solid #eee;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.DailyPlan_taskName__fSNqI {
    flex: 1 1;
    margin-right: 20px;
    word-wrap: break-word;
}

/* 任务信息部分 */
.DailyPlan_taskInfo__ObSO6 {
    display: flex;
    flex-direction: column;
    width: 70%;
}

.DailyPlan_taskHeader__-CLVo {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
}

/* 任务名称的固定宽度和换行支持 */
.DailyPlan_taskDetails__\\+t3xy h5 {
    margin: 0;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
}

/* 加宽Typeahead选择框 */
.DailyPlan_typeaheadWide__H8zct .DailyPlan_rbt__Dd7o3 {
    width: 100%;
}

.DailyPlan_wideSelector__38T6T {
    width: 100%;
    margin-bottom: 20px;
}

/* 设置按钮样式 */
button {
    margin-top: 10px;
}

/* 表单样式 */
.DailyPlan_formGroup__4pDLV {
    margin-bottom: 20px;
}

.DailyPlan_formControl__wq4U1 {
    border-radius: 4px;
    border: 1px solid #ced4da;
    padding: 10px;
    font-size: 16px;
    color: #495057;
}

/* 按钮样式 */
.DailyPlan_btnPrimary__sJg8p {
    background-color: #007bff;
    border-color: #007bff;
    font-size: 16px;
    padding: 10px 20px;
}

.DailyPlan_btnDanger__Nws3T {
    font-size: 14px;
    padding: 5px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Plans/DailyPlan.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,yCAAyC;AAC7C;;AAEA,YAAY;AACZ;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,gBAAgB;AACpB;;AAEA,SAAS;AACT;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB","sourcesContent":["/* 固定容器的宽度为1200px */\r\n.container {\r\n    width: 1200px;\r\n    margin: auto;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* 中心对齐标题 */\r\nh2 {\r\n    text-align: center;\r\n    margin-bottom: 40px;\r\n    font-weight: 700;\r\n    color: #343a40;\r\n}\r\n\r\n/* 任务列表垂直排列，宽度为100% */\r\n.taskList {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    width: 100%;\r\n    margin-top: 20px;\r\n}\r\n\r\n/* 类别组的样式 */\r\n.categoryGroup {\r\n    border: 1px solid #ddd;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    background-color: #fff;\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* 类别标题的样式 */\r\n.categoryTitle {\r\n    margin-bottom: 20px;\r\n    font-weight: 600;\r\n}\r\n\r\n/* 任务详情的样式 */\r\n.taskDetails {\r\n    margin-top: 10px;\r\n    padding: 20px;\r\n    border: 1px solid #eee;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.taskName {\r\n    flex: 1;\r\n    margin-right: 20px;\r\n    word-wrap: break-word;\r\n}\r\n\r\n/* 任务信息部分 */\r\n.taskInfo {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 70%;\r\n}\r\n\r\n.taskHeader {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n/* 任务名称的固定宽度和换行支持 */\r\n.taskDetails h5 {\r\n    margin: 0;\r\n    white-space: normal;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    font-weight: 600;\r\n}\r\n\r\n/* 加宽Typeahead选择框 */\r\n.typeaheadWide .rbt {\r\n    width: 100%;\r\n}\r\n\r\n.wideSelector {\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n/* 设置按钮样式 */\r\nbutton {\r\n    margin-top: 10px;\r\n}\r\n\r\n/* 表单样式 */\r\n.formGroup {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.formControl {\r\n    border-radius: 4px;\r\n    border: 1px solid #ced4da;\r\n    padding: 10px;\r\n    font-size: 16px;\r\n    color: #495057;\r\n}\r\n\r\n/* 按钮样式 */\r\n.btnPrimary {\r\n    background-color: #007bff;\r\n    border-color: #007bff;\r\n    font-size: 16px;\r\n    padding: 10px 20px;\r\n}\r\n\r\n.btnDanger {\r\n    font-size: 14px;\r\n    padding: 5px 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DailyPlan_container__lXHTB`,
	"taskList": `DailyPlan_taskList__p28dx`,
	"categoryGroup": `DailyPlan_categoryGroup__z2aIK`,
	"categoryTitle": `DailyPlan_categoryTitle__MgcOr`,
	"taskDetails": `DailyPlan_taskDetails__+t3xy`,
	"taskName": `DailyPlan_taskName__fSNqI`,
	"taskInfo": `DailyPlan_taskInfo__ObSO6`,
	"taskHeader": `DailyPlan_taskHeader__-CLVo`,
	"typeaheadWide": `DailyPlan_typeaheadWide__H8zct`,
	"rbt": `DailyPlan_rbt__Dd7o3`,
	"wideSelector": `DailyPlan_wideSelector__38T6T`,
	"formGroup": `DailyPlan_formGroup__4pDLV`,
	"formControl": `DailyPlan_formControl__wq4U1`,
	"btnPrimary": `DailyPlan_btnPrimary__sJg8p`,
	"btnDanger": `DailyPlan_btnDanger__Nws3T`
};
export default ___CSS_LOADER_EXPORT___;
